import React from 'react';
import { motion } from 'framer-motion';

export default function Vision() {
  return (
    <div className="min-h-screen px-6 py-16 bg-gradient-to-b from-[#0f0f0f] via-[#1a1a1a] to-[#111] text-white text-center flex flex-col items-center">
      <motion.h1
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-4xl md:text-6xl font-bold mb-4 tracking-tight"
      >
        Vision Board
      </motion.h1>

      <motion.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.1 }}
        className="text-slate-400 text-lg md:text-xl max-w-2xl mb-12"
      >
        Systems, symbols, and the future I’m designing towards. Clear. Earned. Intentional.
      </motion.p>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 w-full max-w-6xl">
        <VisionCard
          title="Mercedes AMG GT 63 S"
          description="Precision, power, poise — my dream sedan for a system-driven life."
          image="/vision/amg.jpg"
        />
        <VisionCard
          title="Rolex for My Family"
          description="Legacy, not luxury. A symbol of giving back with weight and worth."
          image="/vision/rolex.jpg"
        />
        <VisionCard
          title="3-Car Garage"
          description="Hot hatch. Luxe sedan. Quiet monster. One for every aspect of the self."
          image="/vision/garage.jpg"
        />
      </div>
    </div>
  );
}

function VisionCard({ title, description, image }) {
  return (
    <motion.div
      whileHover={{ scale: 1.03 }}
      transition={{ type: 'spring', stiffness: 100 }}
      className="bg-[#181818] rounded-xl overflow-hidden shadow-lg border border-slate-800 hover:border-cyan-500"
    >
      <img src={image} alt={title} className="w-full h-48 object-cover" />
      <div className="p-5">
        <h3 className="text-xl font-semibold mb-2 text-white">{title}</h3>
        <p className="text-slate-400 text-sm">{description}</p>
      </div>
    </motion.div>
  );
}
